import app from 'app';
import templateUrl from './submitClaimMedicalQuestions.html';
import './submitClaimMedicalQuestions.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

import _ from 'lodash';
import moment from 'moment';

function SubmitClaimMedicalQuestions() {
  const SubmitClaimMedicalQuestions = this;

  function formatDOB(dob) {
    return moment(dob).format('MM/DD/YY');
  }

  function getPeople() {
    const nameCounts = _.countBy(
      SubmitClaimMedicalQuestions.plan.dependents,
      'name'
    );
    const dependents = _.sortBy(
      SubmitClaimMedicalQuestions.plan.dependents,
      'name'
    );
    const people = [
      {
        label: 'You',
        value: SubmitClaimMedicalQuestions.plan.submitterId
      }
    ];

    if (dependents.length === 0) {
      return people.concat({
        label: 'Other family member',
        value: 0
      });
    }

    return people.concat(
      dependents.map(x => {
        let label = x.name;
        if (nameCounts[label] > 1) {
          label = `${x.name} (${formatDOB(x.dateOfBirth)})`;
        }

        return {
          label,
          value: x.patientId
        };
      })
    );
  }

  function getNextPage() {
    if (!SubmitClaimMedicalQuestions.alreadyPaid) {
      return 'unpaid_claim';
    }
    return 'verify_bill';
  }

  SubmitClaimMedicalQuestions.back = function() {
    SubmitClaimMedicalQuestions.page = '';
  };

  SubmitClaimMedicalQuestions.next = function() {
    logEvent('MSOONstepCompleted', {
      category: eventCategories.MSOON,
      stepName: 'about your claim'
    });
    SubmitClaimMedicalQuestions.page = getNextPage();
  };

  SubmitClaimMedicalQuestions.hasUnansweredQuestions = function() {
    return (
      _.isUndefined(SubmitClaimMedicalQuestions.alreadyPaid) ||
      _.isUndefined(SubmitClaimMedicalQuestions.patientId)
    );
  };

  SubmitClaimMedicalQuestions.$onInit = function() {
    SubmitClaimMedicalQuestions.yesNoOptions = [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ];
    SubmitClaimMedicalQuestions.people = getPeople();
  };
}

app.component('submitClaimMedicalQuestions', {
  bindings: {
    alreadyPaid: '=',
    cob: '=',
    page: '=',
    patientId: '=',
    plan: '<'
  },
  controller: SubmitClaimMedicalQuestions,
  controllerAs: 'SubmitClaimMedicalQuestions',
  templateUrl
});

export default 'submitClaimMedicalQuestions';
